module.exports = __webpack_public_path__ + "media/images/webpage/hotels/3105/plan1-3-d7abafaee00053d0d27cc27a7ef43f1b.webp";